common.View.create('habitats.website.content.items.Channel', {

	video: null,

	/**
	 * Called when DOM is ready.
	 */
	onDOMLoad()
	{
		this.initPlayProgressTracking();
		this.initGateForm();
	},

	initPlayProgressTracking()
    {
        window._wcq = window._wcq || [];
        window._wcq.push({
            id: "_all",
            onReady: () => this.onWistiaReady()
        });
    },

    onWistiaReady()
    {
	    // Listen for video change.
        Wistia.channel().on("currentvideochange", videoId =>
        {
            // Abort due to no video?
            if (!videoId)
                return;

            // Get video.
            var video = Wistia.api(videoId);

            // Set video as ready.
            this.onVideoReady(video);
        });
	},

	onVideoReady(video)
	{
	    console.info('onVideoReady()', { video });

		//
		this.video = video;

		// Listen for percent watched changed.
		video.on('percentwatchedchanged', _.throttle(this.storeVideoPercentWatched.bind(this), 2500))
	},

	storeVideoPercentWatched(playProgress)
	{
	    console.info('storeVideoPercentWatched()', { playProgress, video: this.video })

		// Store
		$.post(
			this.element.attr('data-track-play-progress-url'),
			{
			    videoId: this.video.data.media.hashedId,
			    playProgress
			}
		);
	},

	initGateForm()
	{
		// Get form instance.
		let formInstance = this.element.find('.habitats-website-content-items-partials-gate-Form').data('instance');

		// Listen for unlock of gate.
		$(formInstance).on('gateUnlocked', () => this.onGateUnlocked());
	},

	onGateUnlocked()
	{
		// Fade out form.
		let form = this.element.find('.form');

		form.fadeOut('slow', () =>
		{
			// Remove form.
			form.remove();

			// @ugly We assume Wistia has already been loaded. Oterwise we might use window._wq.push({
			// Play video.
			this.video.play();
		});
	},

});
